"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.trESForms = undefined;

var _ZipCodeCountryHints = require("./ZipCodeCountryHints");

var trFields = {

	OPTIONAL: {
		DE: "Optional",
		EN: "Optional",
		FR: "non obligatoire"
	},

	NAME: {
		label: {
			ALL: "Name"
		},
		placeHolder: {},
		hint: {
			DE: "Mindestlänge: 2 Zeichen, erlaubte Zeichen: a-z A-Z ß äëïöüÿ ÄËÏÖÜ íáéóúý ÁÉÍÓÚÝ àèìòù ÀÈÌÒÙ âêîôû ÂÊÎÔÛ ãñõ ÃÑÕ åÅ çÇ ðÐ þÞ .-/",
			EN: "Minimum length: 2 characters, allowed characters: a-z A-Z ß äëïöüÿ ÄËÏÖÜ íáéóúý ÁÉÍÓÚÝ àèìòù ÀÈÌÒÙ âêîôû ÂÊÎÔÛ ãñõ ÃÑÕ åÅ çÇ ðÐ þÞ .-/",
			FR: "Longueur minimum: 2 caractères, caractères admissibles: a-z A-Z ß äëïöüÿ ÄËÏÖÜ íáéóúý ÁÉÍÓÚÝ àèìòù ÀÈÌÒÙ âêîôû ÂÊÎÔÛ ãñõ ÃÑÕ åÅ çÇ ðÐ þÞ .-/"
		}
	},

	FIRSTNAME: {
		label: {
			DE: "Vorname",
			EN: "Firstname",
			FR: "Pr\xE9nom"
		},
		placeHolder: {
			DE: "Bitte geben Sie Ihren Vornamen ein",
			EN: "Please enter in your first name",
			FR: "Veuillez entrer votre pr\xE9nom"
		}
	},

	LASTNAME: {
		label: {
			DE: "Nachname",
			EN: "Lastname",
			FR: "Nom"
		},
		placeHolder: {
			DE: "Bitte geben Sie Ihren Nachnamen ein",
			EN: "Please enter your last name",
			FR: "Veuillez entrer votre nom de famille"
		}
	},

	DEPARTMENT: {
		label: {
			DE: "Abteilung",
			EN: "Department",
			FR: "Département"
		},
		placeHolder: {
			DE: "Geben Sie Ihre Abteilung ein",
			EN: "Enter your department",
			FR: "Entrez votre départment"
		},
		hint: {}
	},

	COUNTRY: {
		label: {
			DE: "Land",
			EN: "Country",
			FR: "Pays"
		},
		placeHolder: {
			DE: "W\xE4hlen Sie das Bestimmungsland",
			EN: "Choose the country of destination",
			FR: "Veuillez choisir votre pays"
		},
		hint: {}
	},

	ADDRESSLINE: {
		hint: {
			DE: "Mindestlänge: 2 Zeichen, erlaubte Zeichen: a-z A-Z 0-9 ß äëïöüÿ ÄËÏÖÜ íáéóúý ÁÉÍÓÚÝ àèìòù ÀÈÌÒÙ âêîôû ÂÊÎÔÛ ãñõ ÃÑÕ åÅ çÇ ðÐ þÞ ,.-/",
			EN: "Minimum length: 2 characters, allowed characters: a-z A-Z 0-9 ß äëïöüÿ ÄËÏÖÜ íáéóúý ÁÉÍÓÚÝ àèìòù ÀÈÌÒÙ âêîôû ÂÊÎÔÛ ãñõ ÃÑÕ åÅ çÇ ðÐ þÞ ,.-/",
			FR: "Longueur minimum: 2 caractères, caractères admissibles: a-z A-Z 0-9 ß äëïöüÿ ÄËÏÖÜ íáéóúý ÁÉÍÓÚÝ àèìòù ÀÈÌÒÙ âêîôû ÂÊÎÔÛ ãñõ ÃÑÕ åÅ çÇ ðÐ þÞ ,.-/"
		}
	},

	STREET: {
		label: {
			DE: "Straße",
			EN: "Street",
			FR: "Rue"
		},
		placeHolder: {
			DE: "Bitten geben Sie Ihre Stra\xDFe und Hausnummer ein",
			EN: "Please enter a street and street number",
			FR: "Veuillez entrer une rue et un numéro de rue"
		}
	},

	CITY: {
		label: {
			DE: "Ort",
			EN: "City",
			FR: "Lieu"
		},
		placeHolder: {
			DE: "Bitte geben Sie Ihren Wohnort an",
			EN: "Please enter your city",
			FR: "Veuillez entrer une ville"
		}
	},

	ZIPCODE: {
		label: {
			DE: "Postleitzahl",
			EN: "Zip code",
			FR: "Code postal"
		},
		placeHolder: {
			DE: "Bitte geben Sie die Postleitzahl des Ortes ein",
			EN: "Please enter the ZIP code of the city",
			FR: "Veuillez entrer le code postal de la ville"
		},
		hint: {
			DE: "Mindestlänge: 2 Zeichen, erlaubte Zeichen: a-z A-Z 0-9 -",
			EN: "Minimum length: 2 characters, allowed characters: a-z A-Z 0-9 -",
			FR: "Longueur minimum: 2 caractères, caractères admissibles: a-z A-Z 0-9 -"
		}
	},

	PHONE: {
		label: {
			DE: "Telefonnummer",
			EN: "Phone",
			FR: "Numéro de téléphone"
		},
		placeHolder: {
			DE: "Bitte geben Sie Ihre Telefonnummer ein",
			EN: "Please enter your phone number",
			FR: "Veuillez entrer votre numéro de téléphone"
		},
		hint: {
			DE: "Mindestlänge: 2 Zeichen, erlaubte Zeichen: 0-9 -+",
			EN: "Minimum length: 2 characters, allowed characters: 0-9 -+",
			FR: "Longueur minimum: 2 caractères, caractères admissibles: 0-9 -+"
		}
	},

	EMAIL: {
		label: {
			DE: "E-Mail-Adresse",
			EN: "Email address",
			FR: "Adresse e-mail"
		},
		placeHolder: {
			FR: "Veuillez entrer votre adresse e-mail",
			DE: "Bitte geben Sie Ihre E-Mail-Adresse ein",
			EN: "Please enter your email address"
		},
		hint: {
			DE: "Mindestlänge: 2 Zeichen, erlaubte Zeichen: a-z A-Z 0-9 ._+-",
			EN: "Minimum length: 2 characters, allowed characters: a-z A-Z 0-9 ._+-",
			FR: "Longueur minimum: 2 caractères, caractères admissibles: a-z A-Z 0-9 ._+-"
		}
	},

	PASSWORD: {
		label: {
			DE: "Passwort",
			EN: "Password",
			FR: "Mot de passe"
		},
		placeHolder: {
			DE: "Bitte geben Sie Ihr Passwort ein",
			EN: "Please enter your password",
			FR: "Veuillez entrer votre mot de passe"
		},
		hint: {
			DE: "Mindestlänge: 6 Zeichen, erlaubte Zeichen: a-z A-Z 0-9 ß äöü ÄÖÜ ,.-/_ !?:&",
			EN: "Minimum length: 6 characters, allowed characters: a-z A-Z 0-9 ß äöü ÄÖÜ ,.-/_ !?:&",
			FR: "Longueur minimum: 6 caractères, caractères admissibles: a-z A-Z 0-9 ß äöü ÄÖÜ ,.-/_ !?:&"
		}
	},

	PASSWORD_REPEAT: {
		label: {
			DE: "Passwort bestätigen",
			EN: "Repeat password",
			FR: "Confirmer le mot de passe"
		},
		placeHolder: {
			DE: "Bitte wiederholen Sie Ihr Password",
			EN: "Please confirm your password",
			FR: "Veuillez confirmer votre mot de passe"
		},
		hint: {
			FR: "Veuillez v\xE9rifier votre saisie. Le mot de passe et la v\xE9rification du mot de passe ne correspondent pas.",
			DE: "Bitte \xFCberpr\xFCfen Sie Ihre Eingabe. Das Passwort und die Passwortbest\xE4tigung stimmen nicht \xFCberein.",
			EN: 'Please check the provided password and the password confirmation. These booth entries must match.'

		}
	},

	COMPANY: {
		label: {
			DE: "Firma",
			EN: "Company",
			FR: "Entreprise"
		},
		placeHolder: {
			DE: "Bitte geben Sie den Namen Ihrer Firma ein",
			EN: "Please enter the name of the company",
			FR: "Veuillez entrer le nom de la soci\xE9t\xE9 (en option)"
		},
		hint: {
			DE: "Mindestlänge: 6 Zeichen, erlaubte Zeichen: a-z A-Z 0-9 ß äëïöüÿ ÄËÏÖÜ íáéóúý ÁÉÍÓÚÝ àèìòù ÀÈÌÒÙ âêîôû ÂÊÎÔÛ ãñõ ÃÑÕ åÅ çÇ ðÐ þÞ ,.-/",
			EN: "Minimum length: 6 characters, allowed characters: a-z A-Z 0-9 ß äëïöüÿ ÄËÏÖÜ íáéóúý ÁÉÍÓÚÝ àèìòù ÀÈÌÒÙ âêîôû ÂÊÎÔÛ ãñõ ÃÑÕ åÅ çÇ ðÐ þÞ ,.-/",
			FR: "Longueur minimum: 6 caractères, caractères admissibles: a-z A-Z 0-9 ß äëïöüÿ ÄËÏÖÜ íáéóúý ÁÉÍÓÚÝ àèìòù ÀÈÌÒÙ âêîôû ÂÊÎÔÛ ãñõ ÃÑÕ åÅ çÇ ðÐ þÞ ,.-/"
		}
	},

	VAT_ID: {
		label: {
			DE: "U.St.Id",
			EN: "Tax Id",
			FR: "Votre num\xE9ro fiscal"
		},
		placeHolder: {
			FR: "Votre num\xE9ro fiscal",
			DE: "Ihre USt-IdNr.",
			EN: "Your VAT ID"
		},
		hint: {
			DE: "Bitte geben Sie eine valide USt-IdNr. von Ihrem Land ein.",
			EN: "Please enter a valid VAT number from your country.",
			FR: "Veuillez entrer un numéro de TVA valide de votre pays."
		}
	},

	CUSTOMER_TYPE: {
		label: {
			DE: "Kundenart",
			EN: "Customer type",
			FR: "Type de client"
		},
		placeHolder: {},
		hint: {}
	},

	PRICE: {
		label: {
			DE: "Preis",
			EN: "Price",
			FR: "Prix"
		},
		placeHolder: {},
		hint: {}

	},

	NUMBER: {
		label: {
			ALL: "Number"
		},
		placeHolder: {},
		hint: {}
	},

	SKU: {
		label: {
			ALL: "SKU"
		},
		placeHolder: {
			DE: "Bitte geben Sie die SKU des Produktes ein",
			EN: "Please enter the SKU of the product",
			FR: "Veuillez indiquer le num\xE9ro du produit"
		},
		hint: {
			DE: "",
			EN: "",
			FR: ""
		}
	},

	ORDER: {
		label: {
			DE: "Bestellung",
			EN: "Order",
			FR: "Commande"
		},
		placeHolder: {
			FR: "Veuillez indiquer le num\xE9ro de commande",
			DE: "Bitte geben Sie die Bestellnummer ein",
			EN: "Please enter an order number"
		},
		hint: {
			DE: "",
			EN: "",
			FR: ""
		}
	},

	NEWSLETTER: {
		label: {
			DE: "Newsletter abonnieren?",
			EN: "Subscribe to our newsletter?",
			FR: "S'abonner à notre newsletter ?"
		},
		on: {
			DE: "Ja",
			EN: "Yes",
			FR: "Oui"
		},
		off: {
			DE: "Nein",
			EN: "No",
			FR: "Non"
		}
	},
	GTC: {
		label: {
			DE: "Stimmen Sie Bedingungen zu?",
			EN: "Do you agree to the conditions?",
			FR: "Acceptez-vous nos conditions ?"
		},
		on: {
			DE: "Ja",
			EN: "Yes",
			FR: "Oui"
		},
		off: {
			DE: "Nein",
			EN: "No",
			FR: "Non"
		}
	},
	AMOUNT: {
		label: {
			EN: "Amount",
			DE: "Anzahl"
		},
		placeHolder: {},
		hint: {

			DE: "Die mindest Bestellmenge beträgt Einheiten für dieses Produkt ",
			EN: "Minimum amount is for this product"

		}
	},
	SELECT_DEPARTMENT: {
		label: {},
		placeHolder: {
			'FR': "Veuillez s\xE9lectionner le service que vous souhaitez contacter",
			'DE': "Bitte w\xE4hlen Sie die Abteilung, welche Sie kontaktieren m\xF6chten",
			'EN': 'Select the department which you want to contact'
		},
		hint: {}
	},

	COMMENT: {
		label: {},
		placeHolder: {
			'FR': 'Veuillez entrer votre message',
			'DE': 'Bitte geben Sie Ihre Nachricht ein',
			'EN': 'Please enter your message'
		},
		hint: {
			'FR': 'Veuillez entrer au moins 10 lettres.',
			'DE': 'Bitte geben Sie mindestens 10 Buchstaben ein.',
			'EN': 'Please enter at least 10 letters.'
		}
	},

	SELECT_SUPPORT_REASON: {
		label: {},
		placeHolder: {
			'FR': 'Comment pouvons-nous vous aider?',
			'DE': "Wie k\xF6nnen wir Ihnen helfen?",
			'EN': 'How can we help you?'
		},
		hint: {}
	},

	COUNTRY_OF_ORIGIN: {
		label: {
			EN: "Country of Origin",
			DE: "Ursprungsland"
		},
		placeHolder: {},
		hint: {}
	},
	WEIGHT: {
		label: {
			EN: "Weight",
			DE: "Gewicht"
		},
		placeHolder: {},
		hint: {}
	},
	ManufacturerMSRP: {
		label: {
			EN: "Manufacturer MSRP",
			DE: "Hersteller MSRP"
		},
		placeHolder: {},
		hint: {}
	},
	Text: {
		label: {
			DE: "Text"
		},
		placeHolder: {},
		hint: {}
	}

};

var trESForms = exports.trESForms = {
	translation: {
		DE: "Übersetzung",
		EN: "Translation"
	},
	noTranslationAvailable: {
		DE: "Keine Übersetzung vorhanden.",
		EN: "No translation available."
	},
	languageAdd: {
		DE: "Sprache hinzufügen",
		EN: "Add language"
	},
	toggle: {
		on: {
			DE: "An",
			EN: "On"
		},
		off: {
			DE: "Aus",
			EN: "Off"
		}
	},
	fields: trFields,
	zipCodeCountryHints: _ZipCodeCountryHints.ZipCodeCountryHints
};